import React from 'react';

export default function LastPlaceholder({ lastElementHeight, containerHeight }) {
  const minHeight = (function() {
    if (!lastElementHeight || !containerHeight) return null;
    return containerHeight - lastElementHeight - 30;
  })();
  return minHeight > 0 && <div style={{ minHeight: `${minHeight}px` }}></div>;
}
